import { ReportsMetricsSummary, ReportsOverTimeResponse } from 'dashboard/models/metrics-reports';
import {
  ReportsGranularities,
  ReportsMetricsFilterParams,
} from 'dashboard/redux/reducers/metrics-reports';
import Action from 'lib/interfaces/Action';
import { Iso8601DateString } from 'lib/types';

export type ReportsMetricsActions =
  | Action<ReportsMetricsActionType.SetReportsVolumeSummary, ReportsMetricsVolumeSummaryPayload>
  | Action<ReportsMetricsActionType.SetReportsOverTime, ReportsMetricsOverTimePayload>
  | Action<ReportsMetricsActionType.SetReportsMetricsFilters, ReportsMetricsFiltersPayload>
  | Action<
      ReportsMetricsActionType.SetReportsMetricsGranularities,
      ReportsMetricsGranularitiesPayload
    >
  | Action<ReportsMetricsActionType.ClearMetrics>;

export enum ReportsMetricsActionType {
  SetReportsVolumeSummary = 'metrics/SET_REPORTS_METRICS_SUMMARY',
  SetReportsOverTime = 'metrics/SET_REPORTS_OVER_TIME',
  SetReportsMetricsFilters = 'metrics/SET_REPORTS_METRICS_FILTERS',
  SetReportsMetricsGranularities = 'metrics/SET_REPORTS_PERIODICITIES',
  ClearMetrics = 'metrics/CLEAR_METRICS',
}

interface ReportsMetricsVolumeSummaryPayload {
  volumeSummary: ReportsMetricsSummary[];
  queriedAt: Iso8601DateString;
  updatedAt: Iso8601DateString;
}

interface ReportsMetricsOverTimePayload {
  reportsOverTime: ReportsOverTimeResponse;
  queriedAt: Iso8601DateString;
}

interface ReportsMetricsGranularitiesPayload {
  granularities: ReportsGranularities;
}

interface ReportsMetricsFiltersPayload {
  filters: Partial<ReportsMetricsFilterParams>;
}

export function setReportsMetricsVolumeSummary(
  volumeSummary: ReportsMetricsSummary[],
  queriedAt: Iso8601DateString,
  updatedAt: Iso8601DateString,
): Action<ReportsMetricsActionType.SetReportsVolumeSummary, ReportsMetricsVolumeSummaryPayload> {
  return {
    payload: {
      volumeSummary,
      queriedAt,
      updatedAt,
    },
    type: ReportsMetricsActionType.SetReportsVolumeSummary,
  };
}

export function setReportMetricsGranularities(
  granularities: ReportsGranularities,
): Action<
  ReportsMetricsActionType.SetReportsMetricsGranularities,
  ReportsMetricsGranularitiesPayload
> {
  return {
    payload: {
      granularities,
    },
    type: ReportsMetricsActionType.SetReportsMetricsGranularities,
  };
}

export function setReportsMetricsVolumeOverTime(
  reportsOverTime: ReportsOverTimeResponse,
  queriedAt: Iso8601DateString,
): Action<ReportsMetricsActionType.SetReportsOverTime, ReportsMetricsOverTimePayload> {
  return {
    payload: {
      reportsOverTime,
      queriedAt,
    },
    type: ReportsMetricsActionType.SetReportsOverTime,
  };
}

export function setMetricsFilters(
  filters: Partial<ReportsMetricsFilterParams>,
): Action<ReportsMetricsActionType.SetReportsMetricsFilters, ReportsMetricsFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: ReportsMetricsActionType.SetReportsMetricsFilters,
  };
}
